import { render, staticRenderFns } from "./Applets.vue?vue&type=template&id=6492214a&"
import script from "./Applets.vue?vue&type=script&lang=js&"
export * from "./Applets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports